// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `angular-cli.json`.
import { NgcCookieConsentConfig } from 'ngx-cookieconsent';

const registrationEndpointName = 'regisztracio';
const baseUrl = 'https://dev-service.billcity.hu';

const cookieConfig: NgcCookieConsentConfig = {
  cookie: {
    domain: 'dev-www.billcity.hu', // or 'your.domain.com' // it is mandatory to set a domain, for cookies to work properly (see https://goo.gl/S2Hy2A)
  },
  palette: {
    popup: {
      background: '#000',
    },
    button: {
      background: '#f1d600',
    },
  },
  theme: 'edgeless',
  type: 'opt-out',
  layout: 'my-custom-layout',
  layouts: {
    'my-custom-layout': '{{messagelink}}{{compliance}}',
  },
  elements: {
    messagelink: `
    <span id="cookieconsent:desc" class="cc-message">{{message}}
      <a aria-label="learn more about our privacy policy" tabindex="1" class="cc-link" href="{{privacyPolicyHref}}" target="_blank" rel="noopener">{{privacyPolicyLink}}</a>
    </span>
    `,
    deny: '',
    allow: '<a aria-label="allow cookies" role="button" tabindex="0" class="cc-btn cc-allow">Rendben</a>',
  },
  content: {
    message:
      'A honlap használata közben a magasabb felhasználói élmény érdekében ún. sütiket (cookie) használunk. Kérlek engedélyezd a használatát, amit bármikor vissza is vonhatsz.',

    privacyPolicyLink: 'További információ.',
    privacyPolicyHref:
      'https://s3.eu-central-1.amazonaws.com/billcity.devels/webpage2.0/docs/Billcity+adatv%C3%A9delmi+nyilatkozat.pdf',
  },
};

export const environment = {
  production: true,
  S3_CONFIG: 'https://s3.eu-central-1.amazonaws.com/billcity.hu/dev-config',
  STATS_URL: 'https://s3.eu-central-1.amazonaws.com/billcity.devels/statistics',
  specialEndpoints: {
    registration: registrationEndpointName,
  },
  hideNavBarAndFooterUrls: [`/${registrationEndpointName}`],
  showAdminBar: true,
  backend: {
    regUrl: `${baseUrl}/login/signup`,
  },
  appUrl: 'https://dev-app.billcity.hu',
  cookieConfig,
};
